import axios from "axios";
import { Base_URL } from "../url";

export const saveValuationMethod = async (valuationData) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const userId = userDetails?.userId; 
    const response = await axios.post(
      `${Base_URL}/ValuationMethod/CreateValuationMethod?UserName=${userId}`,
      valuationData
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving valuation method!";
  }
};
